import { StatusType } from 'components'

import { WorkspaceUser } from '../types'

export const translateStatus = (user: WorkspaceUser): StatusType => {
  switch (user.status) {
    case 'active':
      return 'active'
    case 'invited':
      return 'pending'
  }
}
